import { render, staticRenderFns } from "./SupportTicketDetail.vue?vue&type=template&id=fb8c29f8&scoped=true&"
import script from "./SupportTicketDetail.vue?vue&type=script&lang=js&"
export * from "./SupportTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketDetail.vue?vue&type=style&index=0&id=fb8c29f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c29f8",
  null
  
)

export default component.exports